import * as React from 'react';
import { clsx } from 'clsx';

import * as style from '../../style.css';
import { AddButton } from '../AddButton';
import { TableCell } from '../TableCell';

export interface IHeaderRowProps {
  /** Карточки ЖК: обычные или компактные — какие именно, решает вызывающий. */
  columns: React.ReactNode[];
  floating?: boolean;
  pinnedIndex: number | null;
  showAddButton: boolean;
  registerCell(id: string): (node: HTMLDivElement | null) => void;
  rowRef?: React.Ref<HTMLDivElement>;
}

export const HeaderRow = ({
  columns,
  floating = false,
  pinnedIndex,
  showAddButton,
  registerCell,
  rowRef,
}: IHeaderRowProps) => {
  const rowKey = floating ? 'floating-header' : 'header';

  return (
    <div
      ref={rowRef}
      className={clsx(
        style['row'],
        showAddButton && style['row-with-add'],
        !floating && style['row-with-add-no-floating'],
      )}
      role="row"
    >
      {columns.map((column, index) => (
        <TableCell cellRef={registerCell(`${rowKey}::${index}`)} key={index} pinned={index === pinnedIndex}>
          {column}
        </TableCell>
      ))}
      {showAddButton && <AddButton floating={floating} />}
    </div>
  );
};
